import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import type { CargoQuoteRequest } from '../../types/quotes';

interface DashboardHeaderProps {
  userName?: string;
  quotes: CargoQuoteRequest[];
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ userName, quotes }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const firstName = userName?.split(' ')[0] || t('dashboard.header.fallback_name');

  const openOrders = quotes.filter((q) => q.status !== 'rejected');
  const openOrdersCount = openOrders.length;
  const receivedProposalsCount = openOrders.reduce(
    (sum, q) => sum + (q.quote_responses?.length || 0),
    0
  );

  return (
    <div data-testid="dashboard-header" className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div className="space-y-3">
        <h1 className="text-lg lg:text-xl text-foreground">
          {t('dashboard.header.greeting', { name: firstName })}
        </h1>

        <div className="flex flex-wrap gap-3">
          <span className="text-sm text-muted-foreground">{openOrdersCount} {t('dashboard.header.open_orders')} - {receivedProposalsCount} {t('dashboard.header.received_proposals')}</span>
        </div>
      </div>

      <Button
        onClick={() => navigate('/')}
        size="lg"
        className="w-full sm:w-auto shrink-0"
      >
        {t('dashboard.header.new_order_button')}
      </Button>
    </div>
  );
};
